// extracted by mini-css-extract-plugin
module.exports = {"searchModal":"Modal_searchModal__3we2G","closeBtn":"Modal_closeBtn__1uaVs"};